(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avelia-hero"] && !Shopify.designMode) return;
  try {
    
  class AveliaHero extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.track = this.querySelector('[data-hero-track]');
      if (!this.track) return;
      this.slides = Array.from(this.querySelectorAll('.avelia-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.avelia-hero__dot'));
      this.prevBtn = this.querySelector('[data-hero-prev]');
      this.nextBtn = this.querySelector('[data-hero-next]');
      this.currentIndex = 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplayEnabled = this.dataset.autoplay === 'true' && !reducedMotion && this.slides.length > 1;
      this.autoplaySpeed = parseInt(this.dataset.speed, 10) || 5000;
      this.autoplayTimer = null;
      this.isUserInteracting = false;
      if (this.slides.length <= 1) return;
      this.dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          const idx = parseInt(e.currentTarget.dataset.slide, 10);
          this.goToSlide(idx);
          this.pauseAutoplayTemporarily();
        });
      });
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.prev();
          this.pauseAutoplayTemporarily();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.next();
          this.pauseAutoplayTemporarily();
        });
      }
      this.scrollTimer = null;
      this.track.addEventListener('scroll', () => {
        if (this.scrollTimer) clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.handleScroll(), 80);
      }, { passive: true });
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => {
        if (!this.isUserInteracting) this.startAutoplay();
      });
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => {
        if (!this.isUserInteracting) this.startAutoplay();
      });
      this.track.addEventListener('touchstart', () => {
        this.isUserInteracting = true;
        this.stopAutoplay();
      }, { passive: true });
      this.track.addEventListener('touchend', () => {
        setTimeout(() => {
          this.isUserInteracting = false;
          this.startAutoplay();
        }, 2000);
      }, { passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stopAutoplay();
        } else if (this.autoplayEnabled) {
          this.startAutoplay();
        }
      });
      if (this.autoplayEnabled) {
        this.startAutoplay();
      }
      window.addEventListener('resize', () => {
        if (this.resizeTimer) clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.goToSlide(this.currentIndex, false), 150);
      }, { passive: true });
    }
    handleScroll() {
      if (!this.slides[0]) return;
      const slideWidth = this.slides[0].offsetWidth;
      if (slideWidth === 0) return;
      const idx = Math.round(this.track.scrollLeft / slideWidth);
      if (idx !== this.currentIndex && idx >= 0 && idx < this.slides.length) {
        this.currentIndex = idx;
        this.updateActiveDot(idx);
      }
    }
    goToSlide(idx, animate) {
      if (!this.slides[0]) return;
      const slideWidth = this.slides[0].offsetWidth;
      this.track.scrollTo({
        left: slideWidth * idx,
        behavior: animate === false ? 'auto' : 'smooth'
      });
      this.currentIndex = idx;
      this.updateActiveDot(idx);
    }
    next() {
      const nextIdx = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIdx);
    }
    prev() {
      const prevIdx = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIdx);
    }
    updateActiveDot(idx) {
      this.dots.forEach((dot, i) => {
        if (i === idx) {
          dot.classList.add('avelia-hero__dot--active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('avelia-hero__dot--active');
          dot.removeAttribute('aria-current');
        }
      });
    }
    startAutoplay() {
      if (!this.autoplayEnabled) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => this.next(), this.autoplaySpeed);
    }
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
    pauseAutoplayTemporarily() {
      this.stopAutoplay();
      if (this.pauseTimer) clearTimeout(this.pauseTimer);
      this.pauseTimer = setTimeout(() => this.startAutoplay(), 4000);
    }
  }
  if (!customElements.get('avelia-hero')) {
    customElements.define('avelia-hero', AveliaHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var drawer = document.querySelector('[data-cart-drawer]');
  if(!drawer || drawer.dataset.cdInit === '1') return;
  drawer.dataset.cdInit = '1';

  var SID = drawer.getAttribute('data-section-id');
  var html = document.documentElement;
  var timerInt = null;

  function region(){ return drawer.querySelector('[data-cart-rerender]'); }

  function sync(){
    var r = region();
    var n = r ? (parseInt(r.getAttribute('data-item-count'),10) || 0) : 0;
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = n;
      if(!el.classList.contains('cd-count')) el.classList.toggle('is-on', n > 0);
    });
    drawer.classList.toggle('cd-vacio', n === 0);
    var total = drawer.querySelector('[data-cart-total]');
    if(total && r) total.textContent = ' - ' + (r.getAttribute('data-total-money') || '');
  }

  function applyHTML(h){
    var doc = new DOMParser().parseFromString(h, 'text/html');
    var fresh = doc.querySelector('[data-cart-rerender]');
    var cur = region();
    if(fresh && cur){
      cur.innerHTML = fresh.innerHTML;
      cur.setAttribute('data-item-count', fresh.getAttribute('data-item-count'));
      cur.setAttribute('data-total-money', fresh.getAttribute('data-total-money'));
    }
    sync();
    startTimer();
  }

  function refresh(){
    fetch('/?sections=' + SID)
      .then(function(r){ return r.json(); })
      .then(function(d){ if(d[SID]) applyHTML(d[SID]); })
      .catch(function(){});
  }

  function open(){ drawer.classList.add('cd-open'); html.style.overflow = 'hidden'; sync(); startTimer(); refresh(); }
  function close(){ drawer.classList.remove('cd-open'); html.style.overflow = ''; }

  function change(line, qty){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: SID, sections_url: window.location.pathname })
    })
      .then(function(r){ return r.json(); })
      .then(function(state){
        if(state.sections && state.sections[SID]) applyHTML(state.sections[SID]);
        else refresh();
      })
      .catch(function(){});
  }

  drawer.addEventListener('click', function(e){
    var item = e.target.closest('.cd-item');
    if(!item) return;
    var line = parseInt(item.getAttribute('data-line'), 10);
    var q = parseInt(item.querySelector('.cd-qty span').textContent, 10);
    if(e.target.closest('[data-cd-plus]')) change(line, q + 1);
    else if(e.target.closest('[data-cd-minus]')) change(line, Math.max(0, q - 1));
    else if(e.target.closest('[data-cd-remove]')) change(line, 0);
  });

  drawer.querySelectorAll('[data-cart-close]').forEach(function(b){ b.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });

  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-cart-open], a[href$="/cart"], a[href="/cart"], a[href*="/cart?"]');
    if(t){ e.preventDefault(); open(); }
  });

  document.addEventListener('qbk:added', function(){ refresh(); open(); });

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var qbkMulti = document.querySelector('input[data-multi="true"]:checked');
    if(qbkMulti){ return; }
    e.preventDefault();
    e.stopPropagation();
    if(e.stopImmediatePropagation) e.stopImmediatePropagation();
    var data = new FormData(form);
    data.append('sections', SID);
    data.append('sections_url', window.location.pathname);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
      .then(function(r){ return r.json(); })
      .then(function(res){
        if(res.sections && res.sections[SID]) applyHTML(res.sections[SID]);
        else refresh();
        open();
      })
      .catch(function(){ open(); });
  }, true);

  function startTimer(){
    var el = drawer.querySelector('[data-cart-timer]');
    if(!el) return;
    var min = parseFloat(el.getAttribute('data-min')) || 0;
    if(min <= 0) return;
    var end = parseInt(sessionStorage.getItem('cd_timer_end'), 10);
    var now = Date.now();
    if(!end || end < now){ end = now + min * 60000; sessionStorage.setItem('cd_timer_end', end); }
    function tick(){
      var rest = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var m = Math.floor(rest / 60), s = rest % 60;
      el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if(rest <= 0 && timerInt){ clearInterval(timerInt); timerInt = null; }
    }
    if(timerInt) clearInterval(timerInt);
    tick();
    timerInt = setInterval(tick, 1000);
  }

  window.cartDrawerOpen = open;
  sync();
  startTimer();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["encabezado"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close && disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && this.searchModal.close) this.searchModal.close(false);
    }
  }
  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }
  if (!customElements.get('static-header')) {
    customElements.define('static-header', StaticHeader);
  }
  (function() {
    var drawerContainer = null;
    var drawer = null;

    function initDrawer() {
      drawerContainer = document.getElementById('Details-menu-drawer-container');
      if (!drawerContainer) return;
      drawer = drawerContainer.querySelector('.menu-drawer');
      if (!drawer) return;
      if (drawer.parentNode !== document.body) {
        document.body.appendChild(drawer);
      }
      var observer = new MutationObserver(function() {
        if (drawerContainer.hasAttribute('open')) {
          drawer.classList.add('is-open');
        } else {
          drawer.classList.remove('is-open');
          drawer.querySelectorAll('details[open]').forEach(function(d) {
            d.removeAttribute('open');
          });
        }
      });
      observer.observe(drawerContainer, { attributes: true, attributeFilter: ['open'] });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDrawer);
    } else {
      initDrawer();
    }

    function closeDrawer() {
      if (!drawerContainer) drawerContainer = document.getElementById('Details-menu-drawer-container');
      if (drawerContainer) {
        drawerContainer.removeAttribute('open');
        var summary = drawerContainer.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
      if (drawer) {
        drawer.classList.remove('is-open');
        drawer.querySelectorAll('details[open]').forEach(function(d) {
          d.removeAttribute('open');
        });
      }
    }

    document.addEventListener('click', function(event) {
      var link = event.target.closest('.menu-drawer a[href]');
      if (!link || link.tagName !== 'A') return;
      var href = link.getAttribute('href');
      if (!href || href === '#' || href.indexOf('javascript:') === 0) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      closeDrawer();
      setTimeout(function() {
        window.location.assign(href);
      }, 50);
    }, true);

    document.addEventListener('click', function(event) {
      var closeBtn = event.target.closest('.menu-drawer__close-btn, .menu-drawer__close-menu-btn');
      if (closeBtn) {
        event.preventDefault();
        event.stopPropagation();
        closeDrawer();
        return;
      }
      var backBtn = event.target.closest('.menu-drawer__close-button');
      if (backBtn) {
        event.preventDefault();
        var parentDetails = backBtn.closest('details[open]');
        if (parentDetails && !parentDetails.classList.contains('menu-drawer-container')) {
          parentDetails.removeAttribute('open');
        }
        return;
      }
      if (!drawerContainer) drawerContainer = document.getElementById('Details-menu-drawer-container');
      if (drawerContainer && drawerContainer.hasAttribute('open')) {
        if (drawer && drawer.contains(event.target)) return;
        var summary = drawerContainer.querySelector('summary');
        if (summary && summary.contains(event.target)) return;
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        if (!drawerContainer) drawerContainer = document.getElementById('Details-menu-drawer-container');
        if (drawerContainer && drawerContainer.hasAttribute('open')) {
          closeDrawer();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-mas-que-leggings"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    root.querySelectorAll('.mqf-seccion').forEach(function(sec){
      if(sec.dataset.cerrarOtros !== 'true') return;
      var items = sec.querySelectorAll('.mqf-item');
      items.forEach(function(it){
        it.addEventListener('toggle', function(){
          if(it.open){
            items.forEach(function(o){ if(o !== it){ o.open = false; } });
          }
        });
      });
    });
  }
  function boot(){ init(document); }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqqqqq"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initFaq(root){
    if(root.dataset.kvfaqInit === '1') return;
    root.dataset.kvfaqInit = '1';
    var items = root.querySelectorAll('.kvfaq-item');
    items.forEach(function(item){
      var q = item.querySelector('.kvfaq-pregunta');
      if(!q) return;
      q.addEventListener('click', function(){
        var willOpen = !item.classList.contains('active');
        items.forEach(function(i){
          i.classList.remove('active');
          var b = i.querySelector('.kvfaq-pregunta');
          if(b) b.setAttribute('aria-expanded', 'false');
        });
        if(willOpen){
          item.classList.add('active');
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
  function initAll(){ document.querySelectorAll('.kvfaq-seccion').forEach(initFaq); }
  if(document.readyState !== 'loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-resenas-linea"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    root.querySelectorAll('.mqm-marquee').forEach(function(m){
      if(m.dataset.mqmInit === '1') return;
      m.dataset.mqmInit = '1';
      var pista = m.querySelector('.mqm-pista');
      if(!pista) return;
      var pos = 0, last = null, paused = false;
      function vel(){
        var dk = parseFloat(m.getAttribute('data-vel-dk')) || 60;
        var mv = parseFloat(m.getAttribute('data-vel-mv')) || 40;
        return window.matchMedia('(min-width:990px)').matches ? dk : mv;
      }
      if(m.getAttribute('data-pausa') === 'true'){
        m.addEventListener('mouseenter', function(){ paused = true; });
        m.addEventListener('mouseleave', function(){ paused = false; });
      }
      function step(t){
        if(last === null) last = t;
        var dt = (t - last) / 1000; last = t;
        if(!paused){
          pos -= vel() * dt;
          var half = pista.scrollWidth / 2;
          if(half > 0 && -pos >= half){ pos += half; }
          pista.style.transform = 'translateX(' + pos + 'px)';
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }
  function boot(){ init(document); }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-resenas"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var marquees = root.querySelectorAll('.rmkq-marquee');
    marquees.forEach(function(m){
      if(m.dataset.rmkqInit === '1') return;
      m.dataset.rmkqInit = '1';
      var pista = m.querySelector('.rmkq-pista');
      if(!pista) return;
      var pos = 0, last = null, paused = false;
      function vel(){
        var dk = parseFloat(m.getAttribute('data-vel-dk')) || 60;
        var mv = parseFloat(m.getAttribute('data-vel-mv')) || 40;
        return window.matchMedia('(min-width:990px)').matches ? dk : mv;
      }
      if(m.getAttribute('data-pausa') === 'true'){
        m.addEventListener('mouseenter', function(){ paused = true; });
        m.addEventListener('mouseleave', function(){ paused = false; });
      }
      function step(t){
        if(last === null) last = t;
        var dt = (t - last) / 1000; last = t;
        if(!paused){
          pos -= vel() * dt;
          var half = pista.scrollWidth / 2;
          if(half > 0 && -pos >= half){ pos += half; }
          pista.style.transform = 'translateX(' + pos + 'px)';
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }
  function boot(){ document.querySelectorAll('.rmkq-seccion').forEach(init); }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-resenas-draco"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var cont = root.querySelector('.draco-resenas');
    if(!cont) return;
    var wrap = root.querySelector('.draco-tarjeta');
    var cards = Array.prototype.slice.call(cont.querySelectorAll('.draco-card'));
    var btn = cont.querySelector('[data-draco-more]');
    var limM = parseInt(wrap.getAttribute('data-limite-movil'),10) || 4;
    var limD = parseInt(wrap.getAttribute('data-limite-escritorio'),10) || 6;
    var paso = parseInt(wrap.getAttribute('data-paso'),10) || 4;
    var limite = window.innerWidth >= 990 ? limD : limM;
    var visibles = limite;

    function render(){
      cards.forEach(function(c,i){
        if(i < visibles){ c.classList.remove('draco-card--oculta'); }
        else { c.classList.add('draco-card--oculta'); }
      });
      if(btn){ btn.style.display = visibles >= cards.length ? 'none' : 'inline-block'; }
    }
    render();

    if(btn){
      btn.addEventListener('click', function(){
        visibles += paso;
        render();
      });
    }

    root.querySelectorAll('[data-draco-scroll]').forEach(function(a){
      a.addEventListener('click', function(e){
        e.preventDefault();
        cont.scrollIntoView({behavior:'smooth', block:'start'});
      });
    });
  }
  document.querySelectorAll('.draco-wrap').forEach(init);
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('.draco-wrap');
    if(r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-slider-medios"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initSlider(root){
    if(root.dataset.ivsInit === '1') return;
    root.dataset.ivsInit = '1';
    var viewport = root.querySelector('[data-viewport]');
    var track = root.querySelector('[data-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var dotsWrap = root.querySelector('[data-dots]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if(!track || slides.length === 0) return;

    var infinite = root.dataset.tipo === 'infinite';
    var autoplay = root.dataset.autoplay === 'true';
    var speed = (parseFloat(root.dataset.autoplaySpeed) || 5) * 1000;
    var dragEnabled = root.dataset.drag === 'true';
    var index = 0;
    var timer = null;

    function isMobile(){ return window.innerWidth < 990; }
    function per(){ return parseInt(isMobile() ? root.dataset.perM : root.dataset.perD, 10) || 1; }
    function step(){ return parseInt(isMobile() ? root.dataset.scrollM : root.dataset.scrollD, 10) || 1; }
    function gap(){ return parseFloat(getComputedStyle(track).columnGap) || 0; }
    function peek(){ return parseFloat(isMobile() ? root.dataset.peekM : root.dataset.peekD) || 0; }
    function maxIndex(){ return Math.max(0, slides.length - per()); }

    function slideW(){
      var p = per(), g = gap(), pk = peek();
      return (viewport.clientWidth - pk*2 - g*(p-1)) / p;
    }

    function layout(){
      var w = slideW(), pk = peek();
      slides.forEach(function(s){ s.style.width = w + 'px'; });
      track.style.paddingLeft = pk + 'px';
      track.style.paddingRight = pk + 'px';
      go(index, false);
      buildDots();
    }

    function go(i, animate){
      index = Math.max(0, Math.min(maxIndex(), i));
      var w = slideW(), g = gap();
      track.style.transition = animate === false ? 'none' : '';
      track.style.transform = 'translateX(' + (-(index * (w + g))) + 'px)';
      updateDots();
      if(prev) prev.disabled = !infinite && index <= 0;
      if(next) next.disabled = !infinite && index >= maxIndex();
      if(root.dataset.center === 'true') markCenter();
    }

    function nextMove(){
      if(infinite && index >= maxIndex()){ go(0, true); }
      else { go(index + step(), true); }
    }
    function prevMove(){
      if(infinite && index <= 0){ go(maxIndex(), true); }
      else { go(index - step(), true); }
    }

    function buildDots(){
      if(!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for(var i=0;i<slides.length;i++){
        var d = document.createElement('button');
        d.className = 'ivs-dot';
        d.type = 'button';
        d.setAttribute('aria-label', 'Ir a ' + (i+1));
        (function(idx){ d.addEventListener('click', function(){ go(idx, true); restart(); }); })(i);
        dotsWrap.appendChild(d);
      }
      updateDots();
    }
    function updateDots(){
      if(!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.ivs-dot');
      dots.forEach(function(d,j){ d.classList.toggle('is-active', j === index); });
    }
    function markCenter(){
      var mid = index + Math.floor(per()/2);
      slides.forEach(function(s,j){ s.classList.toggle('is-center', j === mid); });
    }

    if(next) next.addEventListener('click', function(){ nextMove(); restart(); });
    if(prev) prev.addEventListener('click', function(){ prevMove(); restart(); });

    function start(){ if(autoplay){ timer = setInterval(nextMove, speed); } }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    function restart(){ stop(); start(); }

    if(dragEnabled){
      var startX = 0, curX = 0, dragging = false, baseTx = 0;
      viewport.addEventListener('pointerdown', function(e){
        dragging = true; startX = e.clientX; baseTx = -(index * (slideW()+gap()));
        track.style.transition = 'none'; stop();
      });
      window.addEventListener('pointermove', function(e){
        if(!dragging) return;
        curX = e.clientX - startX;
        track.style.transform = 'translateX(' + (baseTx + curX) + 'px)';
      });
      window.addEventListener('pointerup', function(){
        if(!dragging) return;
        dragging = false;
        var moved = curX;
        if(Math.abs(moved) > slideW()/4){ moved < 0 ? nextMove() : prevMove(); }
        else { go(index, true); }
        curX = 0; restart();
      });
    }

    var rt;
    window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(layout, 120); });
    layout();
    start();
  }

  function initAll(){ document.querySelectorAll('.ivs-slider').forEach(initSlider); }
  if(document.readyState !== 'loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('click', function(e){
    var playBtn = e.target.closest('[data-play]');
    if(playBtn){
      var wrap = playBtn.closest('[data-video-wrap]');
      var v = wrap && wrap.querySelector('[data-video]');
      if(v){ if(v.paused){ v.play(); playBtn.classList.add('is-hidden'); } else { v.pause(); playBtn.classList.remove('is-hidden'); } }
    }
    var muteBtn = e.target.closest('[data-mute]');
    if(muteBtn){
      var wrap2 = muteBtn.closest('[data-video-wrap]');
      var v2 = wrap2 && wrap2.querySelector('[data-video]');
      if(v2){ v2.muted = !v2.muted; }
    }
  });

  document.addEventListener('timeupdate', function(e){
    var v = e.target;
    if(v.tagName !== 'VIDEO') return;
    var wrap = v.closest('[data-video-wrap]');
    var bar = wrap && wrap.querySelector('[data-timeline]');
    if(bar && v.duration){ bar.style.width = (v.currentTime / v.duration * 100) + '%'; }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-pasos"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var secciones = root.querySelectorAll('.tlps-seccion');
    secciones.forEach(function(sec){
      var items = sec.querySelectorAll('.tlps-item');
      if(!items.length) return;

      function activar(){
        var centro = window.innerHeight / 2;
        var activo = 0, minDist = Infinity;
        items.forEach(function(item, i){
          var r = item.getBoundingClientRect();
          var mid = r.top + r.height / 2;
          var d = Math.abs(mid - centro);
          if(d < minDist){ minDist = d; activo = i; }
        });
        items.forEach(function(item, i){
          item.classList.toggle('tlps-activo', i === activo);
          item.classList.toggle('tlps-pasado', i < activo);
        });
      }

      var ticking = false;
      function onScroll(){
        if(!ticking){
          ticking = true;
          requestAnimationFrame(function(){ activar(); ticking = false; });
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', activar);
      if(window.ResizeObserver){
        var ro = new ResizeObserver(activar);
        items.forEach(function(it){ ro.observe(it); });
      }
      requestAnimationFrame(function(){
        activar();
        setTimeout(activar, 200);
        setTimeout(activar, 600);
      });
    });
  }
  function boot(){ document.querySelectorAll('.tlps-seccion').forEach(function(s){ init(s.parentNode || document); }); }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
